
            import {
                copyToClipBoard,
                getQueryString,
            } from '@src/lib/utils/tools';
            import {UgInvokeApp} from '@src/lib/utils/ugInvokeApp';
            import {showNaToast} from '@lib/utils/native';
            import {os} from '@src/lib/utils/env';
            import {ubcLog} from '@lib/log';
            const invokeBtn = document.getElementById('backflow-btn');
            const copyBtn = document.getElementById('copy-btn');
            const ugInvoke = new UgInvokeApp();
            const {host, protocol} = window.location;
            const url = `${protocol}//${host}/talk/cointask`;
            const inviteCode = getQueryString('inviteCode') || '';
            // 调起场景key
            const sceneName = 'vipcenter_share_fission';
            document.getElementById('conf').textContent = `我的邀请码：${inviteCode}`;

            const sendShareLog = params => {
                const {type, pos} = params;
                ubcLog({
                    ubcId: '6327',
                    params: {
                        type,
                        page: 'vip_new_invite_sharepage',
                        from: 'new_app',
                    },
                    ext: {
                        'click_position': pos,
                    },
                });
            };
            sendShareLog({type: 'display'});
            // 获取调起配置
            ugInvoke.getInvokeInfo({
                [sceneName]: {
                    params: encodeURIComponent(JSON.stringify({
                        url: os.ios ? encodeURIComponent(url) : url,
                        frameExt: {
                            inviteCode,
                        },
                    })),
                },
            });
            // 微信开放标签渲染
            invokeBtn && ugInvoke.renderWxTag({
                wxConf: {
                    wxDom: invokeBtn,
                    onClick: () => {
                        sendShareLog({type: 'click', pos: 'btn'});
                    },
                },
                sceneName,
            });
            // 点击执行调起
            invokeBtn.addEventListener('click', () => {
                sendShareLog({type: 'click', pos: 'btn'});
                ugInvoke.execInvoke(sceneName);
            });
            // 复制邀请码
            copyBtn.addEventListener('click', () => {
                sendShareLog({type: 'click', pos: 'copy'});
                inviteCode && copyToClipBoard(inviteCode);
                showNaToast('已成功复制邀请码，快去填写吧');
            });
            // 微信二次分享
            ugInvoke.setShareData({
                // 分享标题
                title: '帮我助力，有福同享',
                // 分享描述
                desc: '我正在领取30天免费会员权益，来助我一臂之力吧',
                // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                link: location.href,
                // 分享图标
                imgUrl: 'https://newapp-prompt.cdn.bcebos.com/bgimg/2024-08/f202db229e22273c507bb81ed9be77c5.png',
                // 二次分享成功回调
                success: () => {},
            });
        